import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import PolicyContent from './components/PolicyContent';
import FAQSection from './components/FAQSection';

export default function ReturnPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <PolicyContent />
      <FAQSection />
      <Footer />
    </div>
  );
}
